import { Popover } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { DsaTagItemKind, useDsaTags } from "../../hooks/useDsaTags";
import DsaEditTags from "./DsaEditTags";
import "./DsaTags.scss";

interface DsaTagRowProps {
  itemType: DsaTagItemKind;
  itemId: string;
  itemName: string;
  readOnly?: boolean;
}

export default function DsaTagRow({ itemType, itemId, itemName, readOnly }: DsaTagRowProps) {
  const { tagsFor, setItemTag } = useDsaTags();
  const itemTags = tagsFor(itemType, itemId);

  return <div className="dsa-tag-row">
    <span className="label">Tags</span>
    {itemTags.map(t => <span key={t.id} className={`dsa-tag ${readOnly ? "" : "removable"}`}>
      {t.name}
      {!readOnly && <CloseOutlined onClick={() => setItemTag(itemType, itemId, t.id!, false)} />}
    </span>)}
    {!readOnly && <Popover
      trigger="click"
      placement="bottomLeft"
      overlayClassName="dsa-edit-tags-popover"
      content={<DsaEditTags itemType={itemType} itemId={itemId} itemName={itemName} hideTitle />}
    >
      <span className="dsa-tag add">+ Add Tag</span>
    </Popover>}
  </div>;
}
